import { Hud, PerspectiveCamera } from '@react-three/drei'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { SEL_BATTLE_STATE } from '../../c.managers/LevelManager/selectors'
import { BATTLE_STATES } from '../../c.managers/LevelManager/store.d'
import BattleTimer from './components/BattleTimer/BattleTimer'
import BottomBar from './components/BottomBar/BottomBar'
import Deck from './components/Deck/Deck'
import Overlay from './components/Overlay/Overlay'
import TopBar from './components/TopBar/TopBar'

const HUDController = () => {
  const battleState = useSceneStore(SEL_BATTLE_STATE)
  const battleIsActive = battleState === BATTLE_STATES.ONGOING
  return (
    <Hud renderPriority={1}>
      <PerspectiveCamera makeDefault position={[0, 0, 10]} />
      <Overlay show={battleIsActive}>
        <TopBar>
          <BattleTimer />
        </TopBar>
        {/* <LeftBar>
          <CharacterCard>
            Mage
          </CharacterCard>
        </LeftBar> */}
        <BottomBar>
          <Deck />
        </BottomBar>
      </Overlay>
    </Hud>
  )
}

export default HUDController
